import { ListingsAppProps } from '@/types';

export const getLocaleFromProps = (props: Pick<ListingsAppProps, 'pageProps' | 'requestLocale'>): string => {
  return props.pageProps.eventLocale || props.requestLocale || 'en-US';
};
